import React from 'react';
import { IsB2bAgent } from '../../../utils/isB2bAgent';
import { Box, Typography } from '@coolblue-development/freddy';

interface UsernameProps {
  name: string;
}

const UserDetails: React.FC<UsernameProps> = ({ name }) => {
  return (
    <Box>
      <Typography variant="h5" color="white" sx={{ textAlign: 'right' }}>
        {name}
      </Typography>
      <Typography variant="body" color="white">
        {!IsB2bAgent() ? 'Customer Service' : 'Business Journeys'}
      </Typography>
    </Box>
  );
};

export default UserDetails;
